// @ts-nocheck
import { cn } from "../../lib/utils";
import React from "react";

export const BentoGrid = ({
    className,
    children,
}: {
    className?: string;
    children?: React.ReactNode;
}) => {
    return (
        <div
            className={cn(
                "grid gap-4 max-w-7xl mx-auto",
                className
            )}
        >
            {children}
        </div>
    );
};

export const BentoGridItem = ({
    className,
    title,
    description,
    header,
    icon,
    onClick,
}: {
    className?: string;
    title?: string | React.ReactNode;
    description?: string | React.ReactNode;
    header?: React.ReactNode;
    icon?: React.ReactNode;
    onClick?: () => void;
}) => {
    return (
        <div
            className={cn(
                "rounded-2xl overflow-hidden flex flex-col cursor-pointer group/bento",
                "transition-all duration-300",
                className
            )}
            style={{
                background: "linear-gradient(145deg, #111111, #0d0d0d)",
                border: "1px solid rgba(255,255,255,0.08)",
                boxShadow: "0 4px 24px rgba(0,0,0,0.4)",
            }}
            onMouseEnter={(e) => {
                e.currentTarget.style.border = "1px solid rgba(255,255,255,0.18)";
                e.currentTarget.style.boxShadow =
                    "0 8px 40px rgba(0,0,0,0.6), 0 0 0 1px rgba(255,255,255,0.06)";
                e.currentTarget.style.transform = "translateY(-2px)";
            }}
            onMouseLeave={(e) => {
                e.currentTarget.style.border = "1px solid rgba(255,255,255,0.08)";
                e.currentTarget.style.boxShadow = "0 4px 24px rgba(0,0,0,0.4)";
                e.currentTarget.style.transform = "translateY(0)";
            }}
            onClick={onClick}
        >
            {/* Header / Image area */}
            <div className="w-full overflow-hidden" style={{ flex: "1 1 auto" }}>
                {header}
            </div>

            {/* Content area */}
            <div
                className="px-5 py-4 group-hover/bento:translate-x-1 transition-transform duration-300"
                style={{ flexShrink: 0 }}
            >
                {/* Icon */}
                {icon && <div className="mb-2">{icon}</div>}

                {/* Title */}
                <div
                    className="font-bold text-white text-base mb-1 leading-snug"
                    style={{ fontFamily: "inherit" }}
                >
                    {title}
                </div>

                {/* Description */}
                <div
                    className="text-neutral-400 text-sm leading-relaxed"
                    style={{
                        display: "-webkit-box",
                        WebkitLineClamp: 2,
                        WebkitBoxOrient: "vertical",
                        overflow: "hidden",
                    }}
                >
                    {description}
                </div>
            </div>
        </div>
    );
};
